import { Link } from 'react-router-dom';
import '../../../../styles/genericButton.css';
// import {HashLink} from 'react-router-hash-link';
// import { HashLink } from 'react-router-hash-link';
import { HashLink } from 'react-router-hash-link';

function  GenericButton({className, text= "Suivant", isButton=true, to="#", type="button", key= new Date().getSeconds(),isLoading=false, isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    // console.log(text, " : ", form, " : ", "_____----- BUTTON");
    return <>
        {
            isButton=== true ?
            <div className="encaps" style={noCursor?{pointerEvents: "none"} : {}}>
                <button
                    className={`${className} flex space-x-4 group`}
                    type={type}
                    key={key}
                    onClick={onClick}
                    {...rest}
                >
                    <div>
                        {text}
                    </div>
                    {
                        isLoading && (
                            <div className="flex items-center justify-center ">
                                <div className="animate-spin rounded-full h-4 w-4 border border-gray-900 border-t-transparent"></div>
                            </div>
                        )
                    }
                </button>
            </div>
            :
            <div className="encaps">
                {
                    isHash?
                    <HashLink
                        className={className}
                        to={to}
                        key={key}
                        onClick={onClick}
                        smooth
                    >
                        {text}
                    </HashLink>
                    :
                    <Link
                        className={className}
                        to={to}
                        key={key}
                        onClick={onClick}
                    >
                        {text}
                    </Link>
                }
            </div>

        }
    </>;
}

export function RoundWhitePlain({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    // console.log({type})
    return <>
        <GenericButton className={"gradient-btn-plain bg-whiteish " + className} isButton={isButton} text={text}  to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function RoundWhiteOutline({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn bg-whiteish " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function RoundBluePlain({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn-plain bg-darkblueish " + className} isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function RoundBlueOutline({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn bg-darkblueish " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function RoundGreyPlain({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn-plain bg-greyish " + className} isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function RoundGreyOutline({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn bg-greyish " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function GreyOutline({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn bg-greyish square " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function GreyPlain({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn-plain bg-greyish square " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function WhiteOutline({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn bg-whiteish square " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function WhitePlain({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn-plain bg-whiteish square " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function BlueOutline({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn bg-darkblueish square " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}

export function BluePlain({text, isButton=true, to="#", className="", type="button", key= new Date().getSeconds(), isHash=false, noCursor=false, onClick=()=>null, ...rest}: any) {
    return <>
        <GenericButton className={"gradient-btn-plain bg-darkblueish square " + className}  isButton={isButton} text={text} to={to} type={type} key={key} isHash={isHash} noCursor={noCursor} onClick={onClick} {...rest}/>
    </>;
}